angular.module("grantDerogations.components", [])
.component("grantDerogations", {
    templateUrl: "ng/components/grantDerogations/grantDerogations.view.html",
    bindings: {
        model: "="
    },
    controllerAs: "grantDerogationsCtrl",
    controller: function GrantDerogations(){
        var self = this;
        self.$onInit = function(){
        }
    }
})